import { BreakContent } from "../utils/BreakContent";
import { BuildFontString } from "../utils/BuildFontString";
import { fontIconString } from "../utils/fontIconString.js";
import { CenterIt } from "../utils/CenterIt.js";
import { MeasureText } from "../utils/MeasureText";
import { MeasureTextHeight } from "../utils/MeasureTextHeight";
import { SetCtxFont } from "../utils/SetCtxFont";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumFillMode,
  enumFontIconWeights,
  enumStaticTextType,
  kDefStaticHeight,
  kOCNTextColor
} from "../constants";
import { QElement } from "./QElement";

export class QStaticText extends QElement {
  constructor() {
    super();
    this.fLabel = "-Not Set-";
    this.fAlignment = "center";
    this.fPaddingX = 0;

    this.fBold = false;
    this.fItalic = false;
    this.fTextColor = kOCNTextColor;
    this.fFontSize = 12;
    this.fFontName = "Arial";
    this.fUnderLine = false;
    this.fStrikeThrough = false;
    this.fFontString = null;
    this.fType = enumStaticTextType.singleline;
    this.fAvailableWidth = null;

    this.fPriorContent = null;
    this.fPriorContentRows = null;
    this.fMaxRows = 10;
    this.fIconBuffer = 5;
    this.fFillPadding = 0;
    this.fFitRowToSpace = true;
  }

  InitStaticText() {
    this.SetFillMode(enumFillMode.noFill);
    this.fHeight = kDefStaticHeight;
  }

  GetUnderLine() {
    return this.fUnderLine;
  }

  GetStrikeThrough() {
    return this.fStrikeThrough;
  }

  SetUnderline(value) {
    this.fUnderLine = value;
  }

  SetStrikeThrough(value) {
    this.fStrikeThrough = value;
  }

  SetSizingMode(theMode) {
    this.fType = theMode;
  }

  SetFontIcon(fontIcon) {
    this.fFontIcon = fontIcon;
  }

  SetFontIconColor(fontIconColor) {
    this.fFontIconColor = fontIconColor;
  }

  GetFontIconStyle() {
    if (this.fFontIconStyle == null) {
      var fontIconSize = this.fFontSize ? this.fFontSize : 14;
      var fontIconWeight = this.fBold ? enumFontIconWeights.bold : enumFontIconWeights.regular;
      this.fFontIconStyle = fontIconString(fontIconSize, fontIconWeight);
    }
    return this.fFontIconStyle;
  }

  SetAvailableWidth(width) {
    this.fAvailableWidth = width;
  }

  SetPadding(thePadding) {
    this.fPaddingX = thePadding;
  }

  GetLabel() {
    return this.fLabel;
  }

  GetLabelWidth() {
    if (this.fLabelWidth == null) {
      var fs = this.GetFontString();
      this.fLabelWidth = MeasureText(this.fLabel, fs);
      if (this.fFontIcon) {
        this.fLabelWidth += this.GetFontIconLabelWidth() + this.fIconBuffer;
      }
    }
    return this.fLabelWidth;
  }

  GetElementWidth() {
    return this.GetLabelWidth();
  }

  GetFontIconLabelWidth() {
    if (this.fFontIconWidth == null) {
      this.fFontIconWidth = MeasureTextHeight(
        this.GetFontIconStyle(),
        this.fFontSize,
        this.fFontIcon
      );
    }
    return this.fFontIconWidth;
  }

  GetFontString() {
    if (this.fFontString == null)
      this.fFontString = BuildFontString(this.fFontName, this.fFontSize, this.fBold, this.fItalic);
    return this.fFontString;
  }

  RenderText(drawBuffer, txtFillStyle) {
    var ctx = drawBuffer.getContext("2d");

    var fillMode = this.GetFillMode();
    if (fillMode == enumFillMode.solidFill) {
      ctx.fillStyle = this.GetFillColor();
      ctx.fillRect(
        this.fHorzOffset - this.fFillPadding,
        this.fVertOffset,
        this.fWidth + this.fFillPadding * 2,
        this.fHeight
      );
    }

    ctx.fillStyle = txtFillStyle;

    var txt = this.GetLabel();
    var contentRows = this.BreakContent(txt);
    var txtHOffset;
    var n = contentRows.length;
    switch (this.fAlignment) {
      case "right": // set x position of right edge you want text to be aligned (right to left)
      case "left":
        txtHOffset = this.fHorzOffset + this.fPaddingX;
        break;
      case "center":
        txtHOffset = this.fHorzOffset + Div2Floor(this.fWidth); //Math.floor(this.fWidth/2);
        break;
    }

    ctx.textAlign = this.fAlignment;
    ctx.textBaseline = "middle";

    var txtVOffset;
    var rowHeight = 0;

    if (this.fType == enumStaticTextType.singleline) {
      txtVOffset = this.fVertOffset + Div2Floor(this.fHeight); //Math.floor(this.fHeight/2);
    } else {
      rowHeight = this.GetRowHeight();
      txtVOffset = this.fVertOffset + Div2Floor(rowHeight); // Math.floor(rowHeight/2);
    }
    if (this.GetUnderLine()) {
      txtVOffset = this.fVertOffset + Div2Floor(this.fHeight);
      ctx.fillText("", txtHOffset, txtVOffset, MeasureText(txt));
      ctx.fillRect(txtHOffset, txtVOffset * 1.18, MeasureText(txt), 2);
    } else if (this.GetStrikeThrough()) {
      txtVOffset = this.fVertOffset + Div2Floor(this.fHeight);
      ctx.fillText("", txtHOffset, txtVOffset, MeasureText(txt));
      ctx.fillRect(txtHOffset, txtVOffset * 0.88, MeasureText(txt) * 0.97, 2);
    }
    if (this.fFontIcon != null) {
      if (this.fFontIconColor) ctx.fillStyle = this.fFontIconColor;
      var fAStyle = this.GetFontIconStyle();
      SetCtxFont(ctx, fAStyle);
      ctx.fillText(this.fFontIcon, txtHOffset, txtVOffset - 1);
      txtHOffset += MeasureTextHeight(fAStyle, this.fFontSize, this.fFontIcon) + this.fIconBuffer;

      ctx.fillStyle = txtFillStyle;
    }

    var fontStr = this.GetFontString();
    SetCtxFont(ctx, fontStr);

    for (var i = 0; i < n; i++) {
      var txt = contentRows[i];
      if (this.fAvailableWidth != null)
        ctx.fillText(txt, txtHOffset, txtVOffset, this.fAvailableWidth);
      else ctx.fillText(txt, txtHOffset, txtVOffset);
      txtVOffset += rowHeight;
    }
  }

  PrecalculateMinWidth(theString) {
    //var icon = this.GetFontIcon();
    this.CreateMeasureBuffer();
    var ctx = this.fMeasureBuffer.getContext("2d");
    //ctx.font= this.GetFontString();
    var fontStr = this.GetFontString();
    SetCtxFont(ctx, fontStr);
    var txtDim = ctx.measureText(theString);
    var txtWidth = Math.ceil(txtDim.width) + 2 * this.fPaddingX;

    return txtWidth;
  }

  DoCalculateMinWidth() {
    var txt = this.GetLabel();
    var txtWidth = this.PrecalculateMinWidth(txt);
    return txtWidth;
  }

  GetRowHeight() {
    var fontString = this.GetFontString();
    var rowH = MeasureTextHeight(fontString, this.fFontSize);
    rowH += 4;

    return rowH;
  }

  BreakContent(theContent) {
    if (this.fPriorContent == theContent) return this.fPriorContentRows;

    var contentRows = null;
    if (this.fType == enumStaticTextType.singleline) {
      contentRows = new Array();
      contentRows.push(theContent);
    } else {
      var availableWidth = this.fAvailableWidth;
      var cellPadding = this.fPaddingX;
      var rightMargin = cellPadding;
      var leftMargin = cellPadding;
      var fontString = this.GetFontString();

      contentRows = BreakContent(
        theContent,
        this.fMaxRows,
        availableWidth,
        leftMargin,
        rightMargin,
        fontString,
        null
      );
    }

    this.fPriorContent = theContent;
    this.fPriorContentRows = contentRows;

    return contentRows;
  }

  AutoSize() {
    // xPadding
    switch (this.fType) {
      case enumStaticTextType.singleline:
        var txtWidth = this.CalcMinWidth();
        this.SizeElement(txtWidth, this.fHeight);
        break;
      case enumStaticTextType.multiline:
        var txtWidth = this.fAvailableWidth;
        var txt = this.GetLabel();
        var contentRows = this.BreakContent(txt);
        var n = contentRows.length;
        var txtHeight = this.GetRowHeight() * n;
        this.SizeElement(txtWidth, txtHeight);
        break;
    }
  }

  SetTextColor(textColor) {
    this.fTextColor = textColor;
  }

  GetTextColor() {
    return this.fTextColor;
  }

  DoRenderElement(drawBuffer) {
    var txtFillStyle = this.GetTextColor();
    this.RenderText(drawBuffer, txtFillStyle);
  }

  SetLabel(theLabel) {
    this.fLabel = theLabel;
  }

  SetAlignment(theAlignment) {
    this.fAlignment = theAlignment;
  }

  GetAlignment(theAlignment) {
    return this.fAlignment;
  }

  SetItalic(italicText) {
    this.fItalic = italicText;
    this.fFontString = null;
  }

  SetBold(boldText) {
    this.fBold = boldText;
    this.fFontString = null;
  }

  SetFontSize(fontSize) {
    this.fFontSize = fontSize;
    this.fFontString = null;
  }

  SetFontName(fontName) {
    this.fFontName = fontName;
    this.fFontString = null;
  }

  GetLineHeight() {
    if (this.fLineHeight == null) {
      var fontString = this.GetFontString();
      var rowH = MeasureTextHeight(fontString, this.fFontSize);
      rowH += 2;
      this.fLineHeight = rowH;
    }

    return this.fLineHeight;
  }

  CenterOnParent() {
    var parent = this.GetParentPanelRef();
    var parentX = parent.GetPositionX();
    var textX = this.GetPositionX();
    var textW = this.GetLabelWidth();
    this.SetPositionX(CenterIt(parent.fWidth, textW));
  }
}
